import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import NovaSenha from "./nova-senha";

const ModalNovaSenha = ({ isOpen, toggle, email }) => {
	return (
		<Modal isOpen={isOpen} toggle={toggle}>
			<ModalHeader toggle={toggle}>Redefinir senha</ModalHeader>
			<ModalBody>
				<NovaSenha email={email} toggle={toggle} />
			</ModalBody>
		</Modal>
	);
};

export default ModalNovaSenha;
